import Cta from "@components/Cta/Cta";
import { NextContentfulImage } from "@components/Image";
import clsx from "clsx";
import { FC } from "react";
import styles from "./C207_PopularAuthors.module.scss";
import { getAuthorInitials } from "./utils";

type Props = {
  authorName: string;
  title: string;
  imageUrl?: string;
  profileLink?: string;
  articlesLink?: string;
};

export const AuthorItem: FC<Props> = ({
  authorName,
  title,
  articlesLink,
  imageUrl,
  profileLink,
}) => {
  const linkUrl = profileLink || articlesLink;
  return (
    <div className={clsx("flex gap-4", styles["author-item"])}>
      <div className="w-1/3">
        <a
          className={clsx("rounded-full", styles["image-link"])}
          href={linkUrl}
        >
          {imageUrl ? (
            <NextContentfulImage
              src={imageUrl}
              alt={authorName}
              width={100}
              height={100}
              className="rounded-full aspect-1/1 w-full md:w-[136px] md:h-[136px]"
              style={{
                objectFit: "cover",
              }}
            />
          ) : (
            <div
              className={clsx(
                styles["no-profile-picture"],
                "w-full rounded-full aspect-1/1 md:w-[136px] md:h-[136px]"
              )}
            >
              {getAuthorInitials(authorName)}
            </div>
          )}
        </a>
      </div>
      <div className="flex flex-col w-2/3 gap-2 justify-start">
        {authorName && (
          <h3 className={styles["author-name"]}>{authorName}</h3>
        )}
        {title && <p className={styles["author-title"]}>{title}</p>}
        <div>
          <Cta
            type="secondary"
            url={linkUrl}
            linkText={profileLink ? "See profile" : "See articles"}
            customClass={clsx(styles["profile-button"], "h-[48px]")}
          />
        </div>
      </div>
    </div>
  );
};
